import * as d3 from "d3";
import { calcBoundedLimit } from "./utils";

/**
 * @this {import('alpinejs').AlpineComponent}
 */
export default function simpleDonutChart(options) {
  let boundedHeight;
  let boundedWidth;
  let x;
  let arc;
  let data;
  let pie;
  let data_ready;
  let radiusInterne;
  let radiusExterne;
  let colorPalette;
  let show = false;
  let animate = false;

  const scales = () => {
    colorPalette = ["#EC555A", "#FAD0D1"];
    radiusInterne = 40;
    radiusExterne = 50 - 90 / 3.5;

    arc = d3.arc().innerRadius(radiusInterne).outerRadius(radiusExterne);

    x = d3.scaleOrdinal().range(colorPalette.slice(0, data.length));
    x.domain(data);
  };

  const initializeSvg = (width, height, margin) => {
    const { boundedHeight: bh, boundedWidth: bw } = calcBoundedLimit(
      width,
      height,
      margin
    );
    boundedHeight = bh;
    boundedWidth = bw;
  };

  return {
    ...options,
    async init() {
      data = await d3.csv(options.url);
      var isFirefox = typeof InstallTrigger !== "undefined";
      pie = isFirefox
        ? d3
            .pie()
            .value(function (d) {
              return +d?.[options.xIndex];
            })
            .sort(function (a, b) {
              return b?.[options.xIndex] < a?.[options.xIndex];
            })
        : d3
            .pie()
            .value(function (d) {
              return +d?.[options.xIndex];
            })
            .sort(function (a, b) {
              return a?.[options.xIndex] < b?.[options.xIndex];
            });

      data_ready = pie(data);

      this.$watch("width", () => {
        this.show = false;
        // on re-calcule tout
        initializeSvg(this.width, this.height, this.margin);
        scales(this.xIndex, this.offset || 150);
        this.$nextTick(() => (this.show = true));
      });
    },
    translateChart() {
      return `translate(${this.margin.left},${this.margin.top})`;
    },
    get data() {
      return data;
    },
    get data_ready() {
      return data_ready;
    },
    get x() {
      return x;
    },
    set x(a) {
      x = a;
    },
    get arc() {
      return arc;
    },
    set arc(a) {
      arc = a;
    },
    get show() {
      return show;
    },
    set show(s) {
      show = s;
    },
    get animate() {
      return animate;
    },
    set animate(a) {
      animate = a;
    },
  };
}
